import { useSelector } from 'react-redux'

import { EntitlementsState } from '../redux/features/entitlements/entitlementsSlice'

type EntitlementsRootState = {
    entitlements: EntitlementsState
}

// Read the normalized entitlements slice without exposing store-shape details to callers.
export const useEntitlements = (): EntitlementsState =>
    useSelector((state: EntitlementsRootState) => state.entitlements)
